// extracted by mini-css-extract-plugin
export var label = "_kq-2";
export var slideContainer = "_kq-0";
export var slider = "_kq-1";